import Image from 'next/image'

// SSR 圖片組件
export default function CustomImageComponent({
  loading = 'lazy', // 延遲加載，提升性能
  PictureByDevice = false, // 是否根據設備選擇圖片
  ComputerPicturePath, // 桌機圖片路徑
  MobilePicturePath, // 手機圖片路徑
  sizes, // 圖片尺寸屬性
  alt = '', // 強制 alt 屬性，SEO 必須
  deviceType = 'desktop', // 設備類型，由父組件傳入
  ...restProps
}) {
  // 在伺服器端根據 deviceType 選擇圖片來源
  const src = PictureByDevice
    ? deviceType === 'mobile'
      ? MobilePicturePath
      : ComputerPicturePath
    : ComputerPicturePath

  return (
    <Image
      loading={loading}
      src={src}
      sizes={sizes ?? '(max-width: 768px) 100vw, 50vw'} // 響應式尺寸
      alt={alt} // 確保 alt 屬性存在
      {...restProps}
    />
  )
}

// 輔助函數，用於伺服器端選擇圖片路徑
export const GetImagePathByDevice = ({
  PictureByDevice = false,
  ComputerPicturePath,
  MobilePicturePath,
}) => {
  return PictureByDevice ? MobilePicturePath : ComputerPicturePath
}
